module.exports = __webpack_public_path__ + "static/media/mq.b00865ae.svg";